<template>
  <div class="p-4 max-w-xl mx-auto" v-if="!isLoading">
    <div
      @click="$router.back()"
      class="w-10 h-10 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300 cursor-pointer shadow-md transition"
    >
      <BackSvg />
    </div>
    <div class="pb-4 flex flex-col justify-center items-center">
      <h2 class="text-lg text-zinc-700 text-center font-semibold">
        Account Setting
      </h2>
    </div>
    <div>
      <div class="my-10 space-y-3 mx-3">
        <router-link
          to="/portal/account/setting/general"
          class="flex justify-between items-center"
        >
          <div>
            <h2 class="text-sm">General Information</h2>
            <h4 class="text-[11px] text-zinc-500">
              Manage your account details, including your email, mobile and
              profile photo.
            </h4>
          </div>
          <ChevronSVG />
        </router-link>
        <router-link
          to="/portal/account/setting/security"
          class="flex justify-between items-center"
        >
          <div>
            <h2 class="text-sm">Security Information</h2>
            <h4 class="text-[11px] text-zinc-500">
              Control camera & microphone access in your browser
            </h4>
          </div>
          <ChevronSVG />
        </router-link>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="flex items-center justify-center h-48" v-if="isLoading">
      <svg
        class="w-10 h-10 animate-spin text-orange-600"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        ></circle>
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
        ></path>
      </svg>
    </div>
  </div>
</template>
<script>
import { ref, computed, onMounted, inject } from "vue";
import BackSvg from "@/components/svgs/BackSvg.vue";
import ChevronSVG from "@/components/svgs/ChevronRight.vue";
export default {
  name: "TransactionList",
  components: {
    BackSvg,
    ChevronSVG,
  },
  setup() {
    const isLoading = ref(false);
    const moment = inject("$moment");

    const profileImageUrl = computed(() => {
      return localStorage.getItem("patientProfile");
    });

    const dateFormat = (val) => {
      return moment(val).format("LL");
    };

    return {
      dateFormat,
      profileImageUrl,
      isLoading,
    };
  },
};
</script>
